export function getUrlShortReference(url) {
    const urlInfo = url.split("/");
    if (urlInfo.length == 1) {
    return urlInfo[0]
    }
    if (urlInfo[urlInfo.length - 1] == '') {
    return urlInfo[urlInfo.length - 2]
    }
    return urlInfo[urlInfo.length - 1]
}

export function isValidUrl(s){
    try {
        new URL(s);
        return true;
    } catch (err) {
        return false;
    }
}